import { PollQuestionProps } from './types';

export const PollQuestion = ({ question, classNames }: PollQuestionProps) => <p className={`${classNames}`}>{question}</p>;
